var render = function render(){var _vm=this,_c=_vm._self._c;return _c('EkitabuCheckbox',_vm._b({attrs:{"id":_vm.id,"value":_vm.localValue,"label":_vm.label,"disabled":_vm.isUpdating,"loading":_vm.isUpdating,"error":_vm.hasError,"success":_vm.showSuccess},on:{"input":_vm.onInput}},'EkitabuCheckbox',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }